__turbopack_context__.v({
  "actionButton": "toaster-module__uVjLpG__actionButton",
  "closeButton": "toaster-module__uVjLpG__closeButton",
  "content": "toaster-module__uVjLpG__content",
  "description": "toaster-module__uVjLpG__description",
  "error": "toaster-module__uVjLpG__error",
  "icon": "toaster-module__uVjLpG__icon",
  "info": "toaster-module__uVjLpG__info",
  "success": "toaster-module__uVjLpG__success",
  "title": "toaster-module__uVjLpG__title",
  "toast": "toaster-module__uVjLpG__toast",
  "warning": "toaster-module__uVjLpG__warning",
});
